import { createAction } from '@reduxjs/toolkit';

const reset = createAction('reset');

export { reset };
